export type UnixTimestamp = number;

export function toUnixTimestamp(timestamp: number): UnixTimestamp {
  return Math.round(timestamp / 1000);
}

export function fromUnixTimestamp(unixTimestamp: UnixTimestamp): number {
  return unixTimestamp * 1000;
}
